import { FaWhatsapp } from "react-icons/fa";
const FloatingWhatsAppButton = () => {
  return <>
      <style jsx>{`
        @keyframes pulse-bounce {
          0%,
          100% {
            transform: scale(1);
          }

          50% {
            transform: scale(1.1);
          }
        }

        @keyframes float-bounce {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-10px);
          }
        }

        .whatsapp-pulse {
          animation: pulse-bounce 2s ease-in-out infinite;
        }

        .whatsapp-float {
          animation: float-bounce 3s ease-in-out infinite;
        }
      `}</style>

      <a
    href="https://wa.me/94767744180"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
    className="whatsapp-pulse whatsapp-float fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:h-16 hover:w-16 hover:shadow-2xl hover:shadow-[#25D366]/50 md:bottom-8 md:right-8"
    title="Chat with us on WhatsApp"
  >
        <FaWhatsapp className="h-7 w-7 md:h-8 md:w-8" />
      </a>
    </>;
};
export default FloatingWhatsAppButton;
